var map = {
	"./amex_icon.png": "b798",
	"./cirrus_icon.png": "3a71",
	"./delta_icon.png": "a0e9",
	"./diners_icon.png": "78e2",
	"./direct_debit_icon.png": "dc80",
	"./discover_icon.png": "f5af",
	"./ebay_icon.png": "33ac",
	"./jcb_icon.png": "00f8",
	"./maestro_icon.png": "cdb2",
	"./master_icon.png": "4159",
	"./moneybookers_icon.png": "5028",
	"./paypal_icon.png": "d363",
	"./sage_icon.png": "55c4",
	"./solo_icon.png": "81fd",
	"./switch_icon.png": "c282",
	"./troy_icon.png": "a813",
	"./unionpay_icon.png": "e008",
	"./visa_electron_icon.png": "6542",
	"./visa_icon.png": "6690",
	"./western_union_icon.png": "3932"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2789";